import React, {useRef, useState} from "react"
import * as Yup from "yup"
import {useSelector} from "react-redux"
import {useForm} from "react-hook-form"
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from "reactstrap"
import Switch from "react-bootstrap-switch";

// components
import {GenericButton} from "../../../components/buttons/customButtons";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";
import Separator from "../../../components/Separator";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import ModalFormTitle from "../../../components/genericComponents/ModalFormTitle";
import Widgets from "./widgets/Wisgets";

// labels
import {
    PH_BACKGROUND,
    PH_CODE,
    PH_DESCRIPTION,
    PH_NAME,
    PH_ORDER,
    PH_TITLE
} from "../../../components/i18n/placeHolders"
import {
    FORM,
    LB_CODE,
    INTERNATIONAL,
    LB_NAME,
    LB_ORDER,
    LB_STATUS,
    REQUIRED,
    LB_TITLE, LB_BACKGROUND, LB_DESCRIPTION, LB_EVENT
} from "../../../components/i18n/i18n"
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";

// services
import {sectionService} from "../../../jwt/_services/landings/sectionService";

// utils
import {getStateByPath} from "../../../redux/selectors";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import SectionLangs from "./_langs";
import {getCurrentDateForCodeField} from "../../../util/DateTools";
import SelectGeneric from "../../../components/select/selectGeneric";
import {eventProvider} from "../../../providers/eventx/eventProvider";



const SectionForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { udn, app, editMode, domainObject} = componentState?.data;

    const {fbDataBase} = app

    const translatableLangs = domainObject?.translatedLangs || []
    const [langs, setlangs] = useState(domainObject?.langs || []);
    const [status, setStatus] = useState(domainObject?.status || true);
    const [eventId, setEventId] = useState(domainObject?.event?.id || null);

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED ),
    });


    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            code: (domainObject?.code || `SEC_` + getCurrentDateForCodeField()).toUpperCase(), // AUTOCODE
            title: domainObject?.title || '',
            description: domainObject?.description,
            background: domainObject?.background,
            showOrder: domainObject?.showOrder || 0,
        }
    });


    const onSubmit = (data, _) => {
        let dataRequest = {
            fbDataBase,
            item : {
                ...data,
                title: data.title || '_',
                status,
                langs
            }
        };

        if (eventId !== undefined && eventId !== null)
            dataRequest.item.event = { id: eventId };
        else
            dataRequest.item.event = null;

        if (!editMode)
            genericIndexedActions.save(path, sectionService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, sectionService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.onClose()
    }


    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <Card className={'card-modal'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <ModalFormTitle
                    domainObject={domainObject}
                    editMode={editMode}
                />
                <div className={'top-right'}>
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        type={'submit'}
                    />
                    {
                        editMode && <>
                            <GenericButton
                                style={'table'}
                                toolTip={TT_HISTORY}
                                icon={'fa-clock'}
                                permission={'search'}
                                onClick={showHistory}
                            />
                        </>
                    }
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={closeForm}
                    />
                </div>
            </CardTitle>
            <CardBody className={'card-body-modal'}>
                <Row>
                    <Col>
                        {
                            app.code === 'APPLANDING' &&
                                <Row>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>{LB_CODE}</Label>
                                            <Input
                                                type="text"
                                                name="code"
                                                placeholder={PH_CODE}
                                                innerRef={register}
                                            />
                                            {errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>{LB_TITLE}</Label>
                                            <Input
                                                type="text"
                                                name="title"
                                                placeholder={PH_TITLE}
                                                innerRef={register}
                                            />
                                            { errors.title && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.title?.message}</div>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>{LB_BACKGROUND}</Label>
                                            <Input
                                                type="text"
                                                name="background"
                                                placeholder={PH_BACKGROUND}
                                                innerRef={register}
                                            />
                                            { errors.background && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.background?.message}</div>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>{LB_STATUS}</Label>
                                            <br/>
                                            <Switch
                                                animate={true}
                                                offText={"No"}
                                                onText={"Si"}
                                                value={status}
                                                onChange={ () => setStatus(!status) }
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="12">
                                        <FormGroup>
                                            <Label>{LB_DESCRIPTION}</Label>
                                            <Input
                                                type="textarea"
                                                name="description"
                                                placeholder={PH_DESCRIPTION}
                                                innerRef={register}
                                            />
                                            { errors.description && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.description?.message}</div>}
                                        </FormGroup>
                                    </Col>
                                </Row>
                        }
                        {
                            app.code === 'EVENTS' &&
                            <Row>
                                <Input
                                    type="hidden"
                                    name="title"
                                    placeholder={PH_TITLE}
                                    innerRef={register}
                                />
                                <Col md="6">
                                    <FormGroup>
                                        <Label>{LB_CODE}</Label>
                                        <Input
                                            type="text"
                                            name="code"
                                            placeholder={PH_CODE}
                                            innerRef={register}
                                        />
                                        {errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>{LB_ORDER}</Label>
                                        <Input
                                            type="number"
                                            name="showOrder"
                                            step={1}
                                            innerRef={register}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>{LB_STATUS}</Label>
                                        <br/>
                                        <Switch
                                            animate={true}
                                            offText={"No"}
                                            onText={"Si"}
                                            value={status}
                                            onChange={ () => setStatus(!status) }
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={'6'}>
                                    <FormGroup>
                                        <Label>{LB_EVENT}</Label>
                                        <SelectGeneric
                                            provider={eventProvider}
                                            initialValue={eventId}
                                            setExternalValue={setEventId}
                                            customFilter={{ item: { udn: {id: udn?.id }, status: true }} }
                                        />
                                    </FormGroup>
                                </Col>
                                {/*{*/}
                                {/*    app.code === 'EVENTS' &&*/}
                                {/*    <>*/}
                                {/*        <CardTitle className="bg-light border-bottom p-3 mb-0">*/}
                                {/*            <i className="fas fa-language mr-2"/>*/}
                                {/*            { INTERNATIONAL }*/}
                                {/*        </CardTitle>*/}
                                {/*        <CardBody>*/}
                                {/*            <SectionLangs*/}
                                {/*                langs={langs}*/}
                                {/*                setLangs={setlangs}*/}
                                {/*                translatableLangs={translatableLangs}*/}
                                {/*            />*/}
                                {/*        </CardBody>*/}
                                {/*    </>*/}
                                {/*}*/}
                                <Col md={'12'}>
                                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                                        <i className="fas fa-language mr-2"/>
                                        { INTERNATIONAL }
                                    </CardTitle>
                                    <CardBody>
                                        <SectionLangs
                                            langs={langs}
                                            setLangs={setlangs}
                                            translatableLangs={translatableLangs}
                                        />
                                    </CardBody>
                                </Col>
                            </Row>
                        }


                    </Col>
                    {
                        editMode &&
                        <Col>
                            <Widgets path={props.path} />
                        </Col>
                    }
                </Row>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ domainObject }
                />
            }
        </Card>
    </Form>
}
export default SectionForm